import { map, find, pullAllBy } from 'lodash';

class DiscountFormController {
  constructor($rootScope, $scope, $state, discountService, messageService) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.discountService = discountService;
    this.messageService = messageService;
  }

  $onInit() {
    this.discount = this.discount || {};
    this.discount.days = this.discount.days || [];
    this.discount.property_id = this.$rootScope.currentProperty.id;
    this.discount.pricing_value = (this.discount.pricing_type === '%') ? parseInt(this.discount.pricing_value) : this.discount.pricing_value || 0;
  }

  onSave() {
    delete (this.discount.grouped_events);
    delete (this.discount.grouped_exclusions);
    delete (this.discount.grouped_inclusions);

    return this.discountService.save(this.discount)
      .then(response => {
        if (this.discount.id) {
          this.messageService.success(`The discount <strong>${this.discount.code}</strong> was successfully updated!`, [`app.admin.discount-edit({ 'discount' : ${this.discount.id}})`, `Discount`]);
          this.$state.go('app.admin.discounts');
        }else{
          this.messageService.success(`The discount <strong>${response.code}</strong> was successfully created.`);
          this.$state.go('app.admin.discount-edit', {discount: response.id, tab: 'period'});
        }
      })
      .catch((error) => {
        error.data = error.data.original || error.data;
        this.form.$api.setErrors(error.data);

        let sourceElement = Object.keys(error.data);
        let verb = 'created';
        if ( this.discount.id ) {
          verb = 'updated';
        }
        if ( sourceElement.length > 0 ) {
          let errors = '';
          for ( let element of sourceElement ) {
            errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
          }
          this.messageService.failure(`The discount <strong>${this.discount.code}</strong> could not be successfully ${verb}: <ul>${errors}</ul>`);
        } else {
          this.messageService.failure(`The discount <strong>${this.discount.code}</strong> could not be successfully ${verb}: ${error.statusText}`);
        }
        this.messageService.push();
      });
  }

  addDay(day){
    if (!find(this.discount.days, {'day': day.toString()})){
      this.discount.days.push({'day': day.toString()});
    }else{
      pullAllBy(this.discount.days, [{'day': day.toString()}], 'day');
    }
  }

  activeDay(day){
    if (find(this.discount.days, {'day': day.toString()})){
      return 'day-active';
    }
  }
}

DiscountFormController.$inject = [ '$rootScope', '$scope', '$state', 'discountService', 'messageService' ];

export default DiscountFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/controllers/discount.form.controller.js